import React from "react";
import "../../App.css";

const Loader = ({
  className = "",
  loaderTransform = "",
  loaderTransForm = "",
  loaderTranForm = "",
  loaderTansform = "",
  loderTransForm = "",
}) => {
  const wrapperClassName = [
    "loaderBg",
    className,
    loaderTransform,
    loaderTransForm,
    loaderTranForm,
    loaderTansform,
    loderTransForm,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      <div className="loaderArea"></div>
    </div>
  );
};

export default Loader;
